import {
    ADD_TO_LIST_DETAILS
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case ADD_TO_LIST_DETAILS:
            return {
                ...state,
                SUBMIT_loading: false,
                product : action.product,
               
            }
        default:
            return state
    }
}